
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { validEmpty } from '../../utilities/valid';
import { signin } from '../../utilities/httpRequest';
import InputText from '../../components/InputText';

export default function Login() {

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from || '/main';

    const [data, setData] = useState({
        email: {
            value: "",
            valid: ""
        },
        password: {
            value: "",
            valid: ""
        }
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: {
                value: value,
                valid: ""
            }
        })
    }

    const handleSubmit = () => {
        if (validateAllField()) {
            signin(data.email.value, data.password.value, navigate,from);
        }
    }
    const validateAllField = () => {
        let validation = true;
        let dataTmp = { ...data };
        //Champs requis
        if (!validEmpty(data.email.value)) {
            dataTmp.email.valid = "Requis";
            validation = false;
        }
        if (!validEmpty(data.password.value)) {
            dataTmp.password.valid = "Requis";
            validation = false;
        }
        setData(dataTmp);
        return validation;
    }

    return (
        <div className="box-container w-80 min-h-[600px] max-h-[860px] flex flex-col overflow-hidden">
            <img className="p-5" src="/iconslimsvet/logo.png" alt="logo"></img>
            <div className="flex h-10">
                <div className="cursor-pointer hover:bg-[#f5f5f5] w-1/2 flex border-b font-medium text-lg justify-center items-center">Connexion</div>
                <Link className="cursor-pointer hover:bg-[#f5f5f5] w-1/2 flex text-gray font-medium text-lg justify-center items-center" to="inscription">Inscription</Link>
            </div>
            <div className="flex flex-col gap-2 m-3">
                <h1 className="text-base">Informations de connexion</h1>
                <form className="flex flex-col gap-3" onKeyDown={(e) => { if (e.key === "Enter") handleSubmit() }}>
                    <InputText validationLabel={data.email.valid} name="email" value={data.email.value} onChange={handleChange} placeholder="Email" />
                    <InputText password={true} validationLabel={data.password.valid} name="password" value={data.password.value} onChange={handleChange} placeholder="Mot de passe" />
                </form>
                <p className="text-sm text-dark-green">Pas encore inscrit? <Link className="underline" to="inscription">Cliquez ici.</Link></p>
            </div>
            <div className="text-white font-medium text-lg bg-light-green grow max-h-16 min-h-16 mt-auto text-center cursor-pointer flex justify-center items-center mt-3" onClick={handleSubmit}>Connexion &gt;</div>
        </div>
    );
}